//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tippy from 'tippy.js';
import DpIcon from '../icon/Icon.vue';

export default {
  name: 'DpEditableText',
  components: {
    DpIcon,
  },
  props: {
    value: { type: [String, Number], default: null },
    editable: { type: Boolean, default: true },
    tag: { type: String, default: 'h2' },
    updateOnBlur: { type: Boolean, default: false },
    tooltip: { type: String, default: 'Rename' },
  },
  data() {
    return {
      initialValue: '',
      caretPosition: null,
      tippyInstance: null,
    };
  },
  watch: {
    value: {
      async handler() {
        if (!this.caretPosition) return;

        // Wait for the contenteditable element to change it's content
        await this.$nextTick();
        this.setCaretPosition(this.caretPosition);
      },
      immediate: true,
    },
    editable: {
      handler(isEditable) {
        if (!this.tippyInstance) return;
        if (isEditable) {
          this.tippyInstance.enable();
        } else {
          this.tippyInstance.disable();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.tippyInstance = tippy(this.$refs.editElement, {
      content: this.tooltip,
      placement: 'bottom',
      arrow: true,
      allowHTML: true,
    });
  },
  beforeDestroy() {
    if (this.tippyInstance) {
      this.tippyInstance.destroy();
    }
  },
  methods: {
    setCaretPosition(start) {
      const selection = document.getSelection();
      const node = this.$refs.editElement.childNodes[0];

      const range = new Range();
      range.selectNodeContents(this.$refs.editElement);
      range.setStart(node, start <= node.length ? start : node.length);
      range.collapse(true);

      selection.removeAllRanges();
      selection.addRange(range);
    },
    unFocus() {
      this.$refs.editElement.blur();
    },
    handleInput() {
      const currentSelectionRange = document.getSelection().getRangeAt(0);
      this.caretPosition = currentSelectionRange.startOffset;

      if (!this.updateOnBlur) {
        this.pushChanges();
      }
    },
    handlePaste(ev) {
      ev.preventDefault();
      let contentOnBlur = (ev.originalEvent || ev).clipboardData.getData('text/plain');
      contentOnBlur = contentOnBlur.replace(/(<([^>]+)>)/ig, '');
      document.execCommand('insertText', false, contentOnBlur);

      const currentSelectionRange = document.getSelection().getRangeAt(0);
      this.caretPosition = currentSelectionRange.startOffset;
    },
    handleBlur() {
      if (this.updateOnBlur) {
        this.pushChanges();
      }
    },
    beforeInput(ev) {
      const { inputType } = ev;
      // Block new lines
      if (inputType === 'insertParagraph') {
        ev.preventDefault();
      }
    },
    setFocus() {
      this.setCaretPosition(0);
    },
    pushChanges() {
      const srcElement = this.$refs.editElement;
      const newValue = srcElement.value || srcElement.textContent;
      const stripped = newValue.replace(/(\r\n|\n|\r)/gm, '').trim();
      this.$emit('input', stripped);
      this.$emit('change', stripped);
    },
  },
};
